import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Sparkles, ArrowRight } from "lucide-react";
import { blogPosts as mockPosts, blogPillars } from "../mock/mock";
import { getBlog } from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [blogPosts, setBlogPosts] = useState(mockPosts);

  useEffect(() => {
    getBlog()
      .then((data) => { if (Array.isArray(data) && data.length) setBlogPosts(data); })
      .catch(() => {});
  }, []);

  const post = blogPosts.find((p) => p.slug === slug) || blogPosts[0];
  const pillar = blogPillars.find((p) => p.slug === post.pillar);
  const related = blogPosts.filter((p) => p.pillar === post.pillar && p.slug !== post.slug).slice(0, 2);

  return (
    <div>
      <article className="max-w-3xl mx-auto px-5 pt-14 pb-10">
        <Link to="/blog" className="inline-flex items-center gap-2 text-teal font-ui text-sm mb-8 hover:gap-3 transition-all">
          <ArrowLeft size={16} /> Back to Blog
        </Link>
        <span className="font-ui text-xs font-semibold uppercase tracking-wider" style={{ color: pillar?.color }}>{post.pillarLabel}</span>
        <h1 className="font-serif-display text-4xl md:text-5xl font-bold text-navy mt-3 leading-tight">{post.title}</h1>
        <div className="flex items-center gap-3 mt-5 font-ui text-sm text-navy/55">
          <span>By {post.author}</span><span>·</span><span>{post.date}</span><span>·</span><span>{post.readTime} read</span>
        </div>
      </article>

      <div className="max-w-4xl mx-auto px-5">
        <img src={post.img} alt={post.title} className="w-full h-[280px] md:h-[420px] object-cover rounded-2xl" />
      </div>

      <article className="max-w-3xl mx-auto px-5 py-12">
        {/* AI summary */}
        <div className="bg-cream-dark/60 rounded-xl p-6 mb-10 border-l-4" style={{ borderColor: pillar?.color }}>
          <p className="font-ui text-xs font-semibold uppercase tracking-wider mb-2 flex items-center gap-2" style={{ color: pillar?.color }}>
            <Sparkles size={15} /> Quick Answer
          </p>
          <p className="font-serif-body text-xl text-navy leading-relaxed">{post.aiSummary}</p>
        </div>

        <div className="space-y-6 font-ui text-navy/85 text-lg leading-relaxed">
          {post.body.map((para, i) => (<p key={i}>{para}</p>))}
        </div>

        {/* Pillar link back */}
        <div className="mt-12 rounded-2xl p-8 text-cream" style={{ backgroundColor: pillar?.color }}>
          <p className="font-ui text-sm text-white/85 uppercase tracking-wider font-semibold">Want to go deeper?</p>
          <h3 className="font-serif-display text-2xl font-bold mt-2">Read our complete {pillar?.title} guide.</h3>
          <Link to="/blog" className="mt-5 inline-flex items-center gap-2 bg-white/95 text-navy px-6 py-3 rounded-full font-ui font-semibold hover:bg-white transition-colors">
            Explore the pillar <ArrowRight size={17} />
          </Link>
        </div>
      </article>

      {related.length > 0 && (
        <section className="bg-white py-16">
          <div className="max-w-5xl mx-auto px-5">
            <h2 className="font-serif-display text-3xl font-bold text-navy mb-8">More in {post.pillarLabel}</h2>
            <div className="grid sm:grid-cols-2 gap-7">
              {related.map((r) => (
                <Link key={r.slug} to={`/blog/${r.slug}`} className="lift group bg-cream rounded-2xl overflow-hidden border flex" style={{ borderColor: "var(--cream-dark)" }}>
                  <img src={r.img} alt={r.title} className="w-32 object-cover shrink-0" />
                  <div className="p-5">
                    <h3 className="font-serif-display text-lg font-semibold text-navy leading-tight group-hover:text-orange transition-colors">{r.title}</h3>
                    <p className="font-ui text-xs text-navy/55 mt-2">{r.date} · {r.readTime}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
